module.exports = __webpack_public_path__ + "fonts/Lato-HairlineItalic.3220823f.woff";